<template>
  <div>
    <!-- <i class="el-icon-video-play playI"></i> -->
    <img src="../../../assets/音频播放器.png" alt class="mp3Img" @click="bofang1" />
    <audio ref="audio" class="aud" :src="audioUrl"></audio>
  </div>
</template>
 
 
<script>
export default {
  data() {
    return {};
  },
  props: {
    audioUrl: {}
  },

  name: "YinYue",

  components: {},

  methods: {
    bofang1() {
      this.$refs.audio.play();
    }
  }
};
</script>
 
 
 
<style scoped>
.mp3Img {
  width: 20px;
}
.playI {
  color: greenyellow;
}
</style>